export function initEmployeePage() {
  const backBtn = document.querySelector('.employee-back-btn');
  backBtn?.addEventListener('click', checkReferrer, { passive: true });
}

function checkReferrer() {
  const referrer = document.referrer;
  if (!referrer) {
    // return 'No referrer, possibly a direct navigation or same page reload.';
    return (window.location.href = '/');
  }

  const referrerUrl = new URL(referrer);
  const currentUrlObj = new URL(window.location.href);

  if (
    referrerUrl.origin === currentUrlObj.origin &&
    referrerUrl.pathname !== currentUrlObj.pathname
  ) {
    // return 'The referrer is from the same domain but a different page.';
    return window.history.back();
  } else if (referrerUrl.origin !== currentUrlObj.origin) {
    // return 'The referrer is from a different domain.';
    return (window.location.href = '/');
  } else {
    // return 'The referrer is from the same page.';
    return (window.location.href = '/');
  }
}
